define('superAdminMbAnaResGrsView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!superAdminMbAnaResGrsListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var MbAnaResGrListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'mbanaresgrsListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteMbAnaResGr: '.delete-mbanaresgr-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteMbAnaResGr': 'onDeleteMbAnaResGr'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {type: 'mbanaresgrs'};

            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteMbAnaResGr: function(event){
            this.trigger('mbanaresgr:delete', $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'mbanaresgr-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code',
                        width: 30
                    }, {
                        label: _.i18n('common.name'),
                        name: 'name',
                        classes: 'mbanaresgr-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'name'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-mbanaresgr-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            var route = App.getCurrentRoute() ===  'superAdmin/mbanaresgrs' ?
                                App.getCurrentRoute() : 'superAdmin/mbanaresgrs/' + App.getCurrentRoute();
                            App.navigate(route + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = MbAnaResGrListView;
});
